// CartContext.js

import React, { createContext, useState, useContext, useEffect } from "react";

const CartContext = createContext();

const CartProvider = ({ children }) => {
  //   const [cart, setCart] = useState([]);

  // Load cart data from localStorage on component mount
  const initialCart = JSON.parse(localStorage.getItem("cart")) || [];
  const [cart, setCart] = useState(initialCart);

  const [total, setTotal] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  //   const addToCart = (product, quantity) => {
  //     setCart([...cart, { ...product, quantity }]);
  //   };
  const addToCart = (id, imgSrc, name, slug, price, quantity, limit) => {
    setCart([...cart, { id, imgSrc, name, slug, price, quantity, limit }]);
  };

  const removeFromCart = (productId) => {
    const updatedCart = cart.filter((product) => product.id !== productId);
    setCart(updatedCart);
  };

  const updateQuantity = (productId, newQuantity) => {
    const updatedCart = cart.map((product) =>
      product.id === productId ? { ...product, quantity: newQuantity } : product
    );
    setCart(updatedCart);
  };

  const clearCart = () => {
    // Clear cart data from localStorage
    localStorage.removeItem("cart");
    // Clear cart state
    setCart([]);
  };

  const calculateTotal = () => {
    const unroundedTotal = cart.reduce(
      (acc, product) => acc + product.price * product.quantity,
      0
    );
    return parseFloat(unroundedTotal.toFixed(2));
  };

  useEffect(() => {
    // Save cart data to localStorage whenever the cart changes
    localStorage.setItem("cart", JSON.stringify(cart));

    // Recalculate total whenever the cart changes
    const calculatedTotal = calculateTotal();
    setTotal(calculatedTotal);
  }, [cart]);

  const contextValues = {
    cart,
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart,
    total,
    isLoading,
    setIsLoading,
  };

  return (
    <CartContext.Provider value={contextValues}>
      {children}
    </CartContext.Provider>
  );
};

const useCart = () => {
  return useContext(CartContext);
};

export { CartProvider, useCart };
